import EditRewardPromo from './components/EditRewardPromo';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';
import moment from 'moment'

import {
  loadRewardPromos,
  createPromo,
  updatePromo,
  loadPromoDefaults
} from '../../shared/redux/entities/actions';
import './EditRewardPromo.css'
import has from "lodash/has";

function mapStateToProps(state,props){
  const promoId = props.match.params.promoId;
  return {
    promoId:promoId,
    needsLoading:!has(state,['entities','promos',promoId,'name']),
    isCreate:promoId === 'new',
    // defaultValues: {survey: 0.32, offer: 0.25, ad: 0.5},
    defaultValues: get(state,['entities','promoDefaults','defaults'], {}),
    promo:get(state,['entities','promos',promoId], null),
  //   promo: {id:promoId,
  //     name:"Survey 2x - New Year",
  //     startDate: moment(),
  //     endDate: moment().add(7, 'day'),
  //     status:'DRAFT',
  //     domain: "survey",
  //     items: {"guid": {id:"guid", vendor:"tap", imageUrl: "https://storage.googleapis.com/adjoy-app-assets/static/milestones/Survey3XPromo.png", split:30}}
  // },
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRewardPromos,
    createPromo,
    updatePromo,
    loadPromoDefaults
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditRewardPromo));



// WEBPACK FOOTER //
// ./src/routes/EditRewardPromo/index.js